<template>
  <div class="sidebar">
    <div v-if="AuthUser === 'Admin'">
      <div class="sidebar__section">
        <div class="sidebar__section--nav" v-if="item === 'dashboard'">
          <font-awesome-icon icon="poll" />&nbsp;&nbsp;Dashboard
        </div>
        <div class="sidebar__section--nav" v-if="item !== 'dashboard'">
          <routerLink to="/dashboard" active-class="active__link">
            <font-awesome-icon icon="poll" />&nbsp;&nbsp;Dashboard
          </routerLink>
        </div>

        <div class="sidebar__section--nav" v-if="item === 'employee'">
          <font-awesome-icon icon="users" />&nbsp;&nbsp;Employee
        </div>
        <div class="sidebar__section--nav" v-if="item !== 'employee'">
          <routerLink to="/employee" active-class="active__link">
            <font-awesome-icon icon="users" />&nbsp;&nbsp;Employee
          </routerLink>
        </div>

        <div class="sidebar__section--nav" v-if="item === 'wallet'">
          <font-awesome-icon icon="wallet" />&nbsp;&nbsp;Wallet
        </div>
        <div class="sidebar__section--nav" v-if="item !== 'wallet'">
          <routerLink to="/wallet" active-class="active__link">
            <font-awesome-icon icon="wallet" />&nbsp;&nbsp;Wallet
          </routerLink>
        </div>

        <div class="sidebar__section--nav" @click="viewPayrollDropDown">
          <span v-if="payroll !== 'payroll'">
            <font-awesome-icon icon="money-bill-wave" />&nbsp;&nbsp;Payroll
            <font-awesome-icon icon="angle-down" v-show="!payrollDropDown" />
            <font-awesome-icon icon="angle-right" v-show="payrollDropDown" />
          </span>
          <p v-if="payroll === 'payroll'">
            <font-awesome-icon icon="money-bill-wave" />&nbsp;&nbsp;Payroll
            <font-awesome-icon icon="angle-down" v-show="!payrollDropDown" />
            <font-awesome-icon icon="angle-right" v-show="payrollDropDown" />
          </p>
          <div class="sidebar__section--nav-item" v-show="payrollDropDown">
            <div>
              <routerLink
                to="/payroll/regular/initiate"
                active-class="active__link"
                >Run Payroll</routerLink
              >
            </div>

            <div>
              <routerLink to="/onetime-upload" active-class="active__link"
                >Quick Pay</routerLink
              >
            </div>

            <div>
              <div v-if="item === 'payroll'">Payroll History</div>
              <div v-if="item !== 'payroll'">
                <routerLink to="/payroll" active-class="active__link"
                  >Payroll History</routerLink
                >
              </div>
            </div>
          </div>
        </div>

        <div class="sidebar__section--nav" @click="viewHrDropDown">
          <span v-if="hr !== 'hr'">
            <font-awesome-icon icon="balance-scale" />&nbsp;&nbsp;Core HR
            <font-awesome-icon icon="angle-down" v-show="!coreHrDropDown" />
            <font-awesome-icon icon="angle-right" v-show="coreHrDropDown" />
          </span>
          <p v-if="hr === 'hr'">
            <font-awesome-icon icon="balance-scale" />&nbsp;&nbsp;Core HR
            <font-awesome-icon icon="angle-down" v-show="!coreHrDropDown" />
            <font-awesome-icon icon="angle-right" v-show="coreHrDropDown" />
          </p>
          <div class="sidebar__section--nav-item" v-show="coreHrDropDown">
            <!-- <div>
              <div v-if="item === 'query'">Query</div>
              <div v-if="item !== 'query'">
                <routerLink to="/query" active-class="active__link"
                  >Query</routerLink
                >
              </div>
            </div> -->

            <div>
              <div v-if="item === 'promotion'">Promotion</div>
              <div v-if="item !== 'promotion'">
                <routerLink to="/promotion" active-class="active__link"
                  >Promotion</routerLink
                >
              </div>
            </div>

            <div>
              <div v-if="item === 'leave'">Leave</div>
              <div v-if="item !== 'leave'">
                <routerLink to="/leave-management" active-class="active__link"
                  >Leave</routerLink
                >
              </div>
            </div>
          </div>
        </div>

        <!-- start -->

        <div class="sidebar__section--nav" v-if="item === 'benefit'">
          <font-awesome-icon icon="hand-holding-heart" />&nbsp;&nbsp;Benefits
        </div>
        <div class="sidebar__section--nav" v-if="item !== 'benefit'">
          <routerLink to="/benefits" active-class="active__link">
            <font-awesome-icon icon="hand-holding-heart" />&nbsp;&nbsp;Benefits
          </routerLink>
        </div>

        <div class="sidebar__section--nav" @click="viewRecruitmentDropDown">
          <span v-if="item === 'hire'">
            <font-awesome-icon icon="briefcase" />&nbsp;&nbsp;Hire
            <font-awesome-icon
              icon="angle-down"
              v-show="!recruitmentDropDown"
            />
            <font-awesome-icon
              icon="angle-right"
              v-show="recruitmentDropDown"
            />
          </span>
          <span v-if="item !== 'hire'">
            <routerLink to="/hire" active-class="active__link">
              <font-awesome-icon icon="briefcase" />&nbsp;&nbsp;Hire
              <font-awesome-icon
                icon="angle-down"
                v-show="!recruitmentDropDown"
              />
              <font-awesome-icon
                icon="angle-right"
                v-show="recruitmentDropDown"
              />
            </routerLink>
          </span>
          <!-- <div class="sidebar__section--nav-item" v-show="recruitmentDropDown">
            <div>
              <div v-if="item === 'invited'">Invited Candidates</div>
              <div v-if="item !== 'invited'">
                <routerLink to="/invited-candidates" active-class="active__link"
                  >Invited Candidates</routerLink
                >
              </div>
            </div>

            <div>
              <div v-if="item === 'transfer'">Transferred Candidates</div>
              <div v-if="item !== 'transfer'">
                <routerLink
                  to="/transferred-candidates"
                  active-class="active__link"
                  >Transferred Candidates</routerLink
                >
              </div>
            </div>
          </div> -->
        </div>

        <!--
          <div class="sidebar__section--nav" v-if="item === 'report'">
            <font-awesome-icon icon="fax" />&nbsp;&nbsp;Reports
          </div>
          <div class="sidebar__section--nav" v-if="item !== 'report'">
            <routerLink to="/reports" active-class="active__link">
              <font-awesome-icon icon="fax" />&nbsp;&nbsp;Reports
            </routerLink>
          </div>
        -->

        <div class="sidebar__section--nav" v-if="item === 'companydetails'">
          <font-awesome-icon icon="id-card" />&nbsp;&nbsp;Company Details
        </div>
        <div class="sidebar__section--nav" v-if="item !== 'companydetails'">
          <routerLink to="/company-details" active-class="active__link">
            <font-awesome-icon icon="id-card" />&nbsp;&nbsp;Company Details
          </routerLink>
        </div>

        <div class="sidebar__section--nav" v-if="item === 'setting'">
          <font-awesome-icon icon="cogs" />&nbsp;&nbsp;Settings
        </div>
        <div class="sidebar__section--nav" v-if="item !== 'setting'">
          <routerLink to="/settings" active-class="active__link">
            <font-awesome-icon icon="cogs" />&nbsp;&nbsp;Settings
          </routerLink>
        </div>

        <!-- <div class="sidebar__section--nav" v-if="item === 'contact'">
          <font-awesome-icon icon="calendar-check" />&nbsp;&nbsp;Contact hrdesk
        </div>
        <div class="sidebar__section--nav" v-if="item !== 'contact'">
          <routerLink to="/contact" active-class="active__link">
            <font-awesome-icon icon="calendar-check" />&nbsp;&nbsp;Contact
            hrdesk
          </routerLink>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      coreHrDropDown: false,
      payrollDropDown: false,
      recruitmentDropDown: false,
      AuthUser: null,
    };
  },
  props: ["item", "hr", "payroll", "recruit"],
  methods: {
    viewHrDropDown() {
      if (this.coreHrDropDown) {
        this.coreHrDropDown = false;
      } else {
        this.coreHrDropDown = true;
      }
    },
    viewPayrollDropDown() {
      if (this.payrollDropDown) {
        this.payrollDropDown = false;
      } else {
        this.payrollDropDown = true;
      }
    },

    viewRecruitmentDropDown() {
      if (this.recruitmentDropDown) {
        this.recruitmentDropDown = false;
      } else {
        this.recruitmentDropDown = true;
      }
    },
  },
  created() {
    if (this.$store.getters.currentAuthUser.roles.name) {
      this.AuthUser = this.$store.getters.currentAuthUser.roles.name;
    } else {
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  
  overflow: auto;
  padding-bottom: 20px;

  .sidebar__section {
    padding-bottom: 1rem;

    .sidebar__section--nav {
      padding-bottom: 1rem;
      font-size: 1rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.22;
      letter-spacing: normal;
      text-align: left;
      color: #e57414;
      padding-left: 2rem;
      margin-top: 1rem;

      > span {
        color: #000000;
        cursor: pointer;

        &:hover {
          color: #e57414;
        }
      }

      > p {
        color: #e57414;
        cursor: pointer;
        margin: 0;
      }

      .sidebar__section--nav-item {
        padding-left: 15px;

        > div {
          padding-top: 20px;
          color: #000;

          > span {
            color: #e57414;
          }
        }
      }

      a {
        color: #000;
        text-decoration: none;
        &:hover {
          color: #e57414;
        }
      }
    }
  }

  .active__link {
    color: #e57414 !important;
  }
}
</style>
